export type AppTheme = 'dark';


const THEME_BG: Record<AppTheme, string> = {
  dark: '#09090B',
};

export function getSystemTheme(): AppTheme {
  return 'dark';
}

export function readStoredTheme(): AppTheme | null {
  return 'dark';
}

export function readTheme(): AppTheme {
  return 'dark';
}

export function writeTheme(theme: AppTheme): void {
  // no-op, always dark
}

export function isDarkTheme(theme: AppTheme): boolean {
  return true;
}

/** Apply theme to document root — call on init and toggle */
export function applyTheme(theme: AppTheme): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  root.setAttribute('data-theme', 'dark');
  root.setAttribute('data-dash-theme', 'dark');
  root.style.colorScheme = 'dark';
  root.style.backgroundColor = THEME_BG.dark;

  const metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme) {
    metaTheme.setAttribute('content', THEME_BG.dark);
  }

  const metaScheme = document.querySelector('meta[name="color-scheme"]');
  if (metaScheme) {
    metaScheme.setAttribute('content', 'dark');
  }
}

/** Inline script body for public/index.html — must stay in sync with THEME_BG */
export const THEME_INIT_SCRIPT = `
(function(){
  var dark='#09090B';
  var r=document.documentElement;
  r.setAttribute('data-theme','dark');
  r.setAttribute('data-dash-theme','dark');
  r.style.colorScheme='dark';
  r.style.backgroundColor=dark;
})();
`;

/* Backward-compatible exports for dashboardTheme.ts consumers */
export type DashboardTheme = AppTheme;
export const readDashboardTheme = readTheme;
export const writeDashboardTheme = writeTheme;
export const isDashboardDarkMode = isDarkTheme;
